import { render, staticRenderFns } from "./UnuseViewSidebar.vue?vue&type=template&id=65f7ee27&scoped=true&"
import script from "./UnuseViewSidebar.vue?vue&type=script&lang=js&"
export * from "./UnuseViewSidebar.vue?vue&type=script&lang=js&"
import style0 from "./UnuseViewSidebar.vue?vue&type=style&index=0&id=65f7ee27&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f7ee27",
  null
  
)

export default component.exports